var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#CCC","fillRule":"evenodd","d":"M.52 9.259h1.472v9.604h3.689V9.259h2.3l.638-3.176H5.681v-.915c0-.71.119-1.192.357-1.442.239-.249.712-.439 1.261-.439.558 0 1.006.321 1.569.677l.672-2.752C8.506.896 7.661.508 6.58.508c-1.052 0-2.073.183-2.762.547-.688.364-1.185 1.008-1.441 1.587-.257.579-.385 1.284-.385 2.46v.956H.52v3.201z"}));
}

Facebook.defaultProps = {"width":"10","height":"19"};

module.exports = Facebook;

Facebook.default = Facebook;
